'use client';

import { createContext } from 'react';

const GlobalContext = createContext({
  company: {},
  setcompany: () => {},
});

export default GlobalContext;